import { KeyValue } from '@angular/common';
import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faClose, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

import { BlockType } from '@empathy/survey/base';

import { BlockTypeIconConfig } from '../../../models/blocks/block-type-config.constants';
import { BlockTypeConfig } from '../../../models/blocks/block-type-config.interface';
import { BlockTypePickerData } from '../../../models/blocks/block-type-picker-data.interface';

@Component({
  selector: 'empathy-block-type-picker',
  templateUrl: 'block-type-picker.component.html',
  styleUrls: ['./block-type-picker.component.scss', './_block-type-picker-theme.component.scss']
})
export class BlockTypePickerComponent implements OnInit {
  selectedType$ = signal<BlockType>(null);

  blockType = BlockType;
  blockTypeConfig = BlockTypeIconConfig;
  readonly parentBlockTypes = [BlockType.MultiBlock, BlockType.LoopParent];
  blockTypeListOrder = [BlockType.Group, BlockType.Loop];
  readonly showParentBlock = !!this.data?.showParentBlock && !this.data?.loopsOnly;

  faClose = faClose;
  faExclamationTriangle = faExclamationTriangle;

  constructor(
    private dialogRef: MatDialogRef<BlockTypePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BlockTypePickerData
  ) {
    if (this.data?.loopsOnly) {
      this.blockTypeListOrder = [BlockType.Loop];
    }
    this.selectedType$.set(this.showParentBlock ? BlockType.MultiBlock : this.blockTypeListOrder[0]);
  }

  originalOrder = (_a: KeyValue<string, BlockTypeConfig>, _b: KeyValue<string, BlockTypeConfig>): number => 0;

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-block-picker__dialog');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
